<template>
  <a-modal
    v-if="isVisible"
    v-model:open="isVisibleInternal"
    :title="t('profile.route')"
    :footer="null"
    :mask-closable="false"
    :closable="false"
    :keyboard="false"
    destroy-on-close>
    <UserProfile :user="draftUser" @saved="handleSaved" />
  </a-modal>
</template>

<script setup>
import { computed, inject, reactive, ref, watch } from "vue"

import { i18n } from "@/i18n"
import { resolveUserProfileCompletion, userProfileCompletionState } from "@/init/authState"

import UserProfile from "./UserProfile.vue"

const t = (...args) => i18n.global.t(...args)

const currentUser = inject("currentUser", null)

const draftUser = reactive({})

const replaceReactive = (target, source) => {
  if (!target || typeof target !== "object") return
  Object.keys(target).forEach((key) => delete target[key])
  if (source && typeof source === "object") {
    Object.entries(source).forEach(([key, value]) => {
      target[key] = value
    })
  }
}

const isVisible = computed(() => !!userProfileCompletionState.visible)
const isVisibleInternal = ref(false)

watch(
  () => userProfileCompletionState.visible,
  (visible) => {
    isVisibleInternal.value = !!visible
    if (visible && currentUser) {
      replaceReactive(draftUser, currentUser)
    }
  },
  { immediate: true }
)

watch(isVisibleInternal, (open) => {
  if (!open) {
    userProfileCompletionState.visible = false
  }
})

const handleSaved = () => {
  resolveUserProfileCompletion()
}
</script>

<style scoped lang="scss">
</style>
